import {
    FINYEAR_CUSTOMER_REQUEST,
    FINYEAR_CUSTOMER_REQUEST_FAILURE,
    GET_FINYEAR_CUSTOMERS
} from "../types";

const initialState = {
    finyearCustomers: [],
    loading: false,
    error: null,
};

const finyearCustomerReducer = (state = initialState, action) => {
    switch (action.type) {
        case FINYEAR_CUSTOMER_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case GET_FINYEAR_CUSTOMERS: {
            return {
                ...state,
                finyearCustomers: [...action.payload],
                loading: false,
                error: null
            }
        }
        case FINYEAR_CUSTOMER_REQUEST_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            }
        }
        default:
            return state;
    }
};

export default finyearCustomerReducer;
